import { Component } from '@angular/core';

@Component({
  selector: 'app-midjourney-icon',
  template: `
    <div class="center">

    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L3 7V17L12 22L21 17V7L12 2ZM19 16.175L12 20.175L5 16.175V7.825L12 3.825L19 7.825V16.175Z" fill="#4A72FF"/>
      <path d="M12 6L7 9V15L12 18L17 15V9L12 6ZM15 14.175L12 16.175L9 14.175V9.825L12 7.825L15 9.825V14.175Z" fill="#4A72FF"/>
    </svg>
  
    </div>`,
  styleUrls: ['./center.style.css'],
  styles: [':host { display: inline-block; }']
})
export class MidjourneyIconComponent {} 